<template>
  <base-dialog
    :visible.sync="visible"
    :show-close="true"
    width="calc(100vw - 216px)"
    height="calc(100vh - 100px)"
    class="version-detail-dialog"
    border-radius="none"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">
          {{ "[里程碑版本]" + " " + versionCode }}
          <el-tooltip v-if="upContent" class="item" effect="dark" :content="upContent">
            <i class="el-icon-info pointer"></i>
          </el-tooltip>
        </div>
        <base-button type="primary" style="margin-right: 10px;" @click="exportExcel">
          导出
        </base-button>
      </div>
    </template>
    <div class="project-milestone-main">
      <div class="time-line">
        <TimeLine
          style="width: calc(100% - 32px);"
          :milestone-list="milestoneList"
          from="version"
        ></TimeLine>
      </div>
      <div class="milestone-table">
        <MilestoneTaskTable
          style="width: calc(100% - 32px);"
          :milestone-list="milestoneList"
          from="version"
        ></MilestoneTaskTable>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"
import MilestoneTaskTable from "@/views/Front/Project/Milestone/components/MilestoneTaskTable.vue"
import TimeLine from "@/views/Front/Project/Milestone/components/TimeLine.vue"
import { getMilestoneDetail } from "@/api/project/project"
import { milestoneTableColumns } from "@/views/Front/Project/Milestone/static"
import { exportExcel } from "@/views/Backend/Admin/Layout/mixin/export2Excel"
import BaseButton from "@/components/UIComponents/Button.vue"
export default {
  name: "version-detail-dialog",
  components: { BaseButton, MilestoneTaskTable, TimeLine, BaseDialog },
  props: {},
  data() {
    return {
      milestoneList: [],
      visible: false,
      upContent: "",
      versionCode: ""
    }
  },
  methods: {
    async open(version) {
      this.milestoneList = await getMilestoneDetail(version.id)
      this.upContent = version.upContent
      this.versionCode = version.versionCode
      this.getCycle()
      this.visible = true
    },
    // 后一个项目的时间减去前一个项目的时间 算出具体的周期天数
    getCycle() {
      for (let i = 0; i < this.milestoneList.length; i++) {
        this.milestoneList[i].dueDateStr = this.getDaysBetweenDates(
          this.milestoneList[i - 1]?.dueDate,
          this.milestoneList[i]?.dueDate
        )
        this.milestoneList[i].completeAtStr = this.getDaysBetweenDates(
          this.milestoneList[i - 1]?.completeAt,
          this.milestoneList[i]?.completeAt
        )
      }
    },
    getDaysBetweenDates(date1, date2) {
      if (date1 === undefined || date2 === undefined) return ""
      let d1 = new Date(date1)
      let d2 = new Date(date2)
      let timeDiff = Math.abs(d2.getTime() - d1.getTime())
      return Math.ceil(timeDiff / (1000 * 3600 * 24))
    },
    // 导出里程碑任务Excel
    exportExcel() {
      let th = milestoneTableColumns.map(column => column.label)
      let tData = this.milestoneList.map(milestone => {
        let m_key = milestoneTableColumns.map(column => column.prop)
        let m_list = []
        m_key.forEach(k => m_list.push(milestone[k]))
        return m_list
      })
      let tTitle = "[里程碑版本] " + this.versionCode
      exportExcel(th, tData, tTitle)
    }
  }
}
</script>

<style scoped lang="scss">
.version-detail-dialog {
  width: 100%;
  .header-wrap {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
  .project-milestone-main {
    display: flex;
    flex-direction: column;
    .milestone-table,
    .time-line {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #dcdfe6;
    }

    .time-line {
      margin-bottom: 15px;
    }

    .milestone-task-table {
      flex:1;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>
